import {Action, ParseResponse, ResourceContext} from '@refinedev/core';
import {useContext, useMemo} from 'react';
import {useLocation, useParams} from 'react-router';

// parse /(resource)[/:id][/action]
function useMyResourceParams(): ParseResponse {
  const params = useParams();
  const {pathname, search} = useLocation();
  const {resources} = useContext(ResourceContext);
  return useMemo(() => {
    const rx = /\/(\w+)\/?(\w+)?\/?(\w+)?/gi;
    const match = rx.exec(pathname);
    const resource = match?.[1] ? resources.find(r => r.name === match?.[1]) : undefined;
    console.log(match);
    if (!resource) {
      throw new Error(`Resource ${match?.[1]} not found`);
    }
    const id = match?.[2];
    const action = (match?.[3] || 'edit') as Action;
    if (id === 'create') {
      return {
        pathname,
        resource,
        id: undefined,
        action: 'create',
        params,
      };
    }
    // for edit, show, delete
    return {
      pathname,
      resource,
      id: match?.[2],
      action: (match?.[3] || 'edit') as Action,
      params,
    };
  }, [pathname, resources, params]);
}

export default useMyResourceParams;
